import { Injectable } from '@angular/core';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  isDarkTheme: boolean = false;
  isDarkThemeSubject = new Subject<boolean>();

  renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    // Create new renderer from renderFactory, to make it possible to use renderer2 in a service
    this.renderer = rendererFactory.createRenderer(null, null);
    this.setTheme();
  }

  nativeGlobal() { return window; }

  onSwitchTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    this.setTheme();
    this.emitIsDarkTheme();
  }

  setTheme() {
    if (this.isDarkTheme) {
      // Remove the old color-scheme class
      this.renderer.removeClass( document.body, 'color-scheme-light');
      // Add the new / current color-scheme class
      this.renderer.addClass(document.body, 'color-scheme-dark');
    } else {
      // Remove the old color-scheme class
      this.renderer.removeClass( document.body, 'color-scheme-dark');
      // Add the new / current color-scheme class
      this.renderer.addClass(document.body, 'color-scheme-light');
    }
  }

  emitIsDarkTheme() {
    // notify subscriptions and provide them with selected theme
    this.isDarkThemeSubject.next(this.isDarkTheme);
  }

}
